/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiError,
    ApiErrorFromJSON,
    ApiErrorFromJSONTyped,
    ApiErrorToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkspaceConnectionInviteResponseEntry
 */
export interface WorkspaceConnectionInviteResponseEntry {
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConnectionInviteResponseEntry
     */
    statusCode: number;
    /**
     * The unique identifier for the connection.
     * @type {string}
     * @memberof WorkspaceConnectionInviteResponseEntry
     */
    connectionId?: string;
    /**
     * 
     * @type {ApiError}
     * @memberof WorkspaceConnectionInviteResponseEntry
     */
    error?: ApiError;
}

export function WorkspaceConnectionInviteResponseEntryFromJSON(json: any): WorkspaceConnectionInviteResponseEntry {
    return WorkspaceConnectionInviteResponseEntryFromJSONTyped(json, false);
}

export function WorkspaceConnectionInviteResponseEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceConnectionInviteResponseEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'statusCode': json['statusCode'],
        'connectionId': !exists(json, 'connectionId') ? undefined : json['connectionId'],
        'error': !exists(json, 'error') ? undefined : ApiErrorFromJSON(json['error']),
    };
}

export function WorkspaceConnectionInviteResponseEntryToJSON(value?: WorkspaceConnectionInviteResponseEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'statusCode': value.statusCode,
        'connectionId': value.connectionId,
        'error': ApiErrorToJSON(value.error),
    };
}


